export * from './modify-rate.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/modify-rate/index.ts